import { USER_EMAIL } from '../../brands/default/constants';

export const setUserEmail = (userEmail) => (dispatch) => {
  return dispatch({ type: USER_EMAIL.SET_USER_EMAIL, userEmail });
};
